import { orderBy } from "lodash";

/**
 * @param state
 * @returns {{}}
 */
export const getChecklists = ({ checklists }) => {
  return orderBy(orderBy(checklists, "sequence"), "checked");
};

/**
 * @param show_latter
 * @returns {*}
 */
export const isShowLatter = ({ show_latter }) => {
  return show_latter;
};


export const getBreadcrumbsHistory = ({ breadcrumbs }) => 
  breadcrumbs.history;


export const getComponentsKeepAlive = ({ components_keep_alive }) => 
  components_keep_alive;

export const getCommissionPercent = ({ commission_percent }) => 
  commission_percent;
